import { Switch } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { HiMinus, HiPlus } from "react-icons/hi";
import { BsTrash } from "react-icons/bs";
import { HiOutlineX } from "react-icons/hi";
import Modal from "react-modal";
import { TbTruckDelivery } from "react-icons/tb";
import { Link } from "react-router-dom";
import { context } from "../FrontPanel/FrontPanel";
import Login from "../Login/Login";
import axios from "axios";
const Cart = (props) => {
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      padding: "5px",
      width: "99%",
      height: "99%",
    },
  };
  const {
    cart,
    pharmacyDataDetails,
    modalIsOpen,
    setIsOpen,
    isSignedIn,
    setIsLoginOpen,
    address,
    setvatTaxDelivery
  } = useContext(context);

  const { removeProduct, removeQty, addQty, id } = props;

  const [vatAndDelivery, setvatAndDelivery] = useState({
    vat: 0,
    delivery_charge: 0
  });

  useEffect(() => {
    axios
      .get(`setting/${id}`).then((res) => {

        if (Object.entries(res.data).length !== 0) {
          setvatAndDelivery({
            vat: parseInt(res.data.vat),
            delivery_charge: parseInt(res.data.delivery_charge)
          })
          setvatTaxDelivery({
            vat: parseInt(res.data.vat),
            delivery_charge: parseInt(res.data.delivery_charge)
          })
        } else {
          setvatAndDelivery({
            vat: 0,
            delivery_charge: 0
          })
          setvatTaxDelivery({
            vat: 0,
            delivery_charge: 0
          })
        }

      })
      .catch((err) => {
        console.log(err)
      });
  }, [id])

  const subTotal = cart.reduce(
    (totalPrice, item) =>
      totalPrice + parseFloat(item.price) * parseFloat(item.qty),
    0
  );
  const per = (parseFloat(vatAndDelivery.vat) / 100) * parseFloat(subTotal)
  const total = subTotal + per + vatAndDelivery.delivery_charge
  return (
    <div className="cart-container custom-shadow px-3 ml-[1px] pb-4">
      <div className="cart-for-large hidden lg:block">
        <div className="text-center py-5">
          <p className="text-[#8C8C8C]">
            Delivery <Switch color="warning" /> Pick-Up
          </p>
          <TbTruckDelivery className="text-[30px] inline text-[#909090]" />
          <p className="text-[#8C8C8C]">15 Min</p>
          <h6 className="font-bold">
            Your order from {pharmacyDataDetails?.store_name} - {address}
          </h6>
        </div>
        <div className="cart-items">
          {cart.length > 0 &&
            cart.map((item, i) => (
              <div key={i} className="grid grid-cols-12 mb-1">
                <div className="col-span-9">
                  <p className="text-[#134E47] font-semibold text-sm">
                    {item.name} {item.macrohealth_sg}
                  </p>
                </div>
                <div className="col-span-3 text-right">
                  <p className="text-[#8C8C8C] font-semibold text-sm">
                    {item.price}
                  </p>
                  <div className="flex justify-between ml-4">
                    {item.qty === 1 ? (
                      <BsTrash
                        onClick={() => removeProduct(item)}
                        className="cursor-pointer rounded mt-1 text-[15px] text-[#BC0000] mr-1"
                      />
                    ) : (
                      <HiMinus
                        onClick={() => removeQty(item)}
                        className="cursor-pointer rounded mt-1 text-[14px] bg-[#BC0000] text-white mr-1"
                      />
                    )}

                    <p className="text-[#134E47] select-none">{item.qty}</p>
                    <HiPlus
                      onClick={() => addQty(item)}
                      className="cursor-pointer rounded mt-1 text-[14px] bg-[#134E47] text-white "
                    />
                  </div>
                </div>
                {/* <div className="col-span-1 flex justify-end">
                            <HiOutlineX onClick={() => removeProduct(item)} className='hover:text-[red] inline cursor-pointer' />
                        </div> */}
              </div>
            ))}

          <hr className="border" />
          <div className="grid grid-cols-12">
            <div className="col-span-9">
              <p className="text-[#8C8C8C] text-sm">Subtotal</p>
            </div>
            <div className="col-span-3 text-right">
              <p className="text-[#8C8C8C] text-sm">
                <span style={{ fontSize: "15px", fontWeight: 500 }}>

                  &#x9F3;
                </span>
                {subTotal > 0 ? subTotal.toFixed(2) : "0.00"}
              </p>
            </div>
          </div>
          <div className="grid grid-cols-12">
            <div className="col-span-9">
              <p className="text-[#8C8C8C] text-sm">Delivery fee</p>
            </div>
            <div className="col-span-3 text-right">
              <p className="text-[#8C8C8C] text-sm">
                <span style={{ fontSize: "15px", fontWeight: 500 }}>

                  &#x9F3;
                </span>
                {
                  vatAndDelivery?.delivery_charge
                }
              </p>
            </div>
          </div>
          <div className="grid grid-cols-12">
            <div className="col-span-9">
              <p className="text-[#8C8C8C] text-sm">VAT</p>
            </div>
            <div className="col-span-3 text-right">
              <p className="text-[#8C8C8C] text-sm">
                <span style={{ fontSize: "15px", fontWeight: 500 }}>
                </span>
                {
                  vatAndDelivery?.vat
                }%
              </p>
            </div>
          </div>
          <div className="grid grid-cols-12">
            <div className="col-span-9">
              <p className="text-[#134E47] font-semibold text-sm">
                Total(Incl. VAT)
              </p>
            </div>
            <div className="col-span-3 text-right">
              <p className="text-[#134E47] font-semibold text-sm">
                <span style={{ fontSize: "15px", fontWeight: 500 }}>

                  &#x9F3;
                </span>
                {total > 0 ? total.toFixed(2) : "0.00"}
              </p>
            </div>
            <div className="col-span-12">
              {cart.length > 0 && (
                <>
                  {isSignedIn ? (
                    <Link to={`/checkout/${id}`}>
                      <button className="w-full mt-3 py-1 bg-[#134E47] text-white font-medium rounded-lg">
                        Go to checkout
                      </button>
                    </Link>
                  ) : (
                    <button
                      onClick={() => setIsLoginOpen(true)}
                      className="w-full mt-3 py-1 bg-[#134E47] text-white font-medium rounded-lg"
                    >
                      Go to checkout
                    </button>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <div
        className={`${cart.length > 0 ? "block" : "hidden"
          } lg:hidden small-cart`}
      >
        <div className="view-cart fixed bottom-0 w-full h-[44px] pr-5 ">
          <button
            onClick={() => setIsOpen(true)}
            className="w-full mt-3 py-1 bg-[#134E47] text-white font-medium rounded-lg"
          >
            View Cart
          </button>
        </div>
      </div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => setIsOpen(false)}
        style={customStyles}
        contentLabel="our modal"
      >
        <div className="modal-header bg-white  py-2 px-2">
          <h6 className="text-lg font-bold mb-1">

            <HiOutlineX
              onClick={() => setIsOpen(false)}
              className="inline float-right cursor-pointer"
            />
          </h6>
          <div className="sm:w-[500px] mx-auto">
            <div className="text-center py-5">
              <p className="text-[#8C8C8C]">
                Delivery <Switch color="default" /> Pick-Up
              </p>
              <TbTruckDelivery className="text-[30px] inline text-[#909090]" />
              <p className="text-[#8C8C8C]">15 Min</p>
              <h6 className="font-bold">Your order from Al Shifa - Lalbag</h6>
            </div>
            <div className="cart-items">
              {cart.length > 0 &&
                cart.map((item, i) => (
                  <div key={i} className="grid grid-cols-12 mb-1">
                    <div className="col-span-9">
                      <p className="text-[#134E47] font-semibold text-sm">
                        {item.name || item.macrohealth_sg}
                      </p>
                    </div>
                    <div className="col-span-3 text-right">
                      <p className="text-[#8C8C8C] font-semibold text-sm">
                        {item.price}
                      </p>
                      <div className="flex justify-between ml-4">
                        {item.qty === 1 ? (
                          <BsTrash
                            onClick={() => removeProduct(item)}
                            className="cursor-pointer rounded mt-1 text-[15px] text-[#BC0000] mr-1"
                          />
                        ) : (
                          <HiMinus
                            onClick={() => removeQty(item)}
                            className="cursor-pointer rounded mt-1 text-[14px] bg-[#BC0000] text-white mr-1"
                          />
                        )}

                        <p className="text-[#134E47] select-none">{item.qty}</p>
                        <HiPlus
                          onClick={() => addQty(item)}
                          className="cursor-pointer rounded mt-1 text-[14px] bg-[#134E47] text-white "
                        />
                      </div>
                    </div>
                    {/* <div className="col-span-1 flex justify-end">
                            <HiOutlineX onClick={() => removeProduct(item)} className='hover:text-[red] inline cursor-pointer' />
                        </div> */}
                  </div>
                ))}

              <hr className="border" />
              <div className="grid grid-cols-12">
                <div className="col-span-9">
                  <p className="text-[#8C8C8C] text-sm">Subtotal</p>
                </div>
                <div className="col-span-3 text-right">
                  <p className="text-[#8C8C8C] text-sm">
                    $ {subTotal > 0 ? subTotal.toFixed(2) : "0.00"}
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-12">
                <div className="col-span-9">
                  <p className="text-[#8C8C8C] text-sm">Delivery fee</p>
                </div>
                <div className="col-span-3 text-right">
                  <p className="text-[#8C8C8C] text-sm">$ 0.00</p>
                </div>
              </div>
              <div className="grid grid-cols-12">
                <div className="col-span-9">
                  <p className="text-[#134E47] font-semibold text-sm">
                    Total(Incl. VAT)
                  </p>
                </div>
                <div className="col-span-3 text-right">
                  <p className="text-[#134E47] font-semibold text-sm">
                    $ {subTotal > 0 ? subTotal.toFixed(2) : "0.00"}
                  </p>
                </div>
                {/* <div className="col-span-12">
                  <Link to={`/checkout/${id}`}>
                    <button className=" w-full mt-3 py-1 bg-[#134E47] text-white font-medium rounded-lg">
                      Go to checkout
                    </button>
                  </Link>
                </div> */}
                <div className="col-span-12">
                  {cart.length > 0 && (
                    <>
                      {isSignedIn ? (
                        <Link to={`/checkout/${id}`}>
                          <button className="w-full mt-3 py-1 bg-[#134E47] text-white font-medium rounded-lg">
                            Go to checkout
                          </button>
                        </Link>
                      ) : (
                        <button
                          onClick={() => setIsLoginOpen(true)}
                          className="w-full mt-3 py-1 bg-[#134E47] text-white font-medium rounded-lg"
                        >
                          Go to checkout
                        </button>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* <button onClick={() => setIsOpen(true)} className="w-[97%] mt-3 py-1 bg-[#134E47] text-white font-medium rounded-lg absolute bottom-0">Go to checkout</button> */}
        </div>
      </Modal>
      <Login />
    </div>
  );
};

export default Cart;
